export const routesTanitim = [
  {
    path: "/fatura",
    name: "fatura",
    component: () => import("@/views/fatura/index.vue"),
    meta: {
      public: false,
      title: "Fatura",
      // yetki: { k: [], a: true },
    },
  },
  {
    path: "/gelirgider",
    name: "gelirgider",
    component: () => import("@/views/gelirgider/index.vue"),
    meta: {
      public: false,
      title: "Gelir Gider",
      // yetki: { k: [], a: true },
    },
  },
  {
    path: "/sube_tanitim",
    name: "sube_tanitim",
    component: () => import("@/views/tanitim/sube/index.vue"),
    meta: {
      public: false,
      title: "Şube",
      yetki: { k: [], a: true },
    },
  },
  {
    path: "/harcama-tur",
    name: "harcama_tur",
    component: () => import("@/views/harcama_tur/index.vue"),
    meta: {
      public: false,
      title: "Harcama Tür",
      yetki: { k: [], a: true },
    },
  },
  {
    path: "/harcama-tur-rapor",
    name: "harcama_tur_rapor",
    component: () => import("@/views/harcama_tur/rapor/index.vue"),
    meta: {
      public: false,
      title: "Harcama Tür Raporu",
      yetki: { k: [], },
    },
  },
];
